window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

/**
 * Cart scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the quanity inputs in any `cart/add` forms that may
 * exist.
 *
 * @namespace Cart
 */

slate.Cart = (function() {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Cart() {
    // this.$container = options.$container;
    // this.product = options.product;
    // this.$addToCart = $(options.addToCart, options.$container);
    // this.$addToCartText = $(options.addToCartText, options.$container);
    // this.$form = $(options.form, options.$container);
    // this.$form.on("submit", this._addToCart.bind(this));
    var self = this;
    this.getCart();
    this.$cartContainer = $(".cart-container");
    this.$cartCount = $("[data-cart-count]");
    $(window).on("updateCart", this.getCart.bind(this));
    this.settings = {};
    this.$cartNavItem = $(".cart-nav");
    var timeout;
    var $html = $("html");

    if (!$html.hasClass("touchevents")) {
      this.$cartNavItem.hover(
        function() {
          clearTimeout(timeout);
          self.$cartContainer.addClass("show");
        },
        function() {
          clearTimeout(timeout);
          timeout = setTimeout(function() {
            self.$cartContainer.removeClass("show");
          }, 150);
        }
      );
    }
  }

  Cart.prototype = $.extend({}, Cart.prototype, {
    cookiesEnabled: function() {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled) {
        document.cookie = "testcookie";
        cookieEnabled = document.cookie.indexOf("testcookie") !== -1;
      }
      return cookieEnabled;
    },
    getCart: function() {
      jQuery.getJSON("/cart.js", this._onGetCartSuccess.bind(this));
    },
    _onGetCartSuccess: function(cart, textStatus) {
      // if ((typeof callback) === 'function') {
      //   callback(cart);
      // }
      // else {
      //   ShopifyAPI.onCartUpdate(cart);
      // }
      // console.log(cart);
      this.$cartCount.text(cart.item_count);
      this._buildCart(cart);
    },

    _buildCart: function(cart) {
      // Start with a fresh cart div
      this.$cartContainer.empty();

      // Show empty cart
      if (cart.item_count === 0) {
        var source =
          '<p class="cart--empty-message">' +
          // "{{ 'cart.general.empty' | t | json }}" +
          "your shopping bag is empty" +
          "</p>" +
          '<p class="cookie-message">' +
          // "{{ 'cart.general.cookies_required' | t | json }}" +
          "</p>";
        var template = Handlebars.compile(source);
        this.$cartContainer.append(template());
        // cartCallback(cart);
        return;
      }

      // Handlebars.js cart layout
      var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);

      // Add each item to our handlebars.js data
      $.each(cart.items, function(index, cartItem) {
        /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
        if (cartItem.image != null) {
          var prodImg = cartItem.image
            .replace(/(\.[^.]*)$/, "_medium$1")
            .replace("http:", "");
        } else {
          var prodImg =
            "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
        }

        if (cartItem.properties !== null) {
          $.each(cartItem.properties, function(key, value) {
            if (key.charAt(0) === "_" || !value) {
              delete cartItem.properties[key];
            }
          });
        }

        // Create item's data object and add to 'items' array
        item = {
          key: cartItem.key,
          line: index + 1, // Shopify uses a 1+ index in the API
          url: cartItem.url,
          img: prodImg,
          title: cartItem.product_title,
          variation: cartItem.variant_title,
          properties: cartItem.properties,
          itemAdd: cartItem.quantity + 1,
          itemMinus: cartItem.quantity - 1,
          itemQty: cartItem.quantity,
          price: slate.Currency.formatMoney(cartItem.price),
          discountedPrice: slate.Currency.formatMoney(
            cartItem.price - cartItem.total_discount / cartItem.quantity
          ),
          discounts: cartItem.discounts,
          discountsApplied:
            cartItem.price === cartItem.price - cartItem.total_discount
              ? false
              : true,
          vendor: cartItem.vendor,
        };

        items.push(item);
      });

      // Gather all cart data and add to DOM
      data = {
        items: items,
        note: cart.note,
        totalPrice: slate.Currency.formatMoney(cart.total_price),
        totalCartDiscount:
          cart.total_discount === 0
            ? 0 : 0
            // : "{{ 'cart.general.savings_html' | t: price: '[savings]' | json }}".replace(
            //     "[savings]",
            //     slate.Currency.formatMoney(cart.total_discount)
            //   ),
      };

      this.$cartContainer.append(template(data));
    },
  });

  return Cart;
})();

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {

      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        // return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();

/**
 * Quantity Update scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the quantity in any `cart/add` forms that may
 * exist.
 *
 * @namespace quantity
 */

slate.Quantity = (function() {
    /**
     * Variant constructor
     *
     * @param {object} options - Settings from `product.js`
     */
    function Quantity(options) {
      this.$container = options.$container;
      this.product = options.product;
      this.$quantityInput = $(options.quantityInput, options.$container);
      this.quantityUpdate = options.quantityUpdate;
      
      $(this.quantityUpdate, this.$container).on('click', this._updateQuantity.bind(this));
    }
  
    Quantity.prototype = $.extend({}, Quantity.prototype, {
      _updateQuantity: function(evt) {
        var mod = $(evt.target).data('productQuantityUpdate');
        var quantity = parseInt(this.$quantityInput.val())  + mod;
        if (quantity <= 0 ) quantity = 1;
        this.$container.trigger({
          type: 'updateQuantity',
          quantity: quantity
        });
      },
    });
  
    return Quantity;
  })();
  
/**
 * Add to Cart scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the quanity inputs in any `cart/add` forms that may
 * exist.
 *
 * @namespace AddToCart
 */

slate.AddToCart = (function() {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function AddToCart(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.$addToCart = $(options.addToCart, options.$container);
    this.$addToCartText = $(options.addToCartText, options.$container);
    this.$form = $(options.form, options.$container);
    this.$form.on("submit", this._addToCart.bind(this));
  }

  AddToCart.prototype = $.extend({}, AddToCart.prototype, {
    _addToCart: function(evt) {
      evt.preventDefault();
      // this.$container.trigger({
      //   type: "addToCart",
      //   form: this.$form,
      // });
      this.$addToCartText.html('adding');
      this._addToCartFromForm(this.$form);
    },
    _addToCartFromForm: function (form) {
      // var form = evt.form;
      // this.$addToCartText.html('adding');
      var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: jQuery(form).serialize(),
        dataType: 'json',
        success: this._onItemAdded.bind(this),
        error: this._errorCallback.bind(this),
      };
      jQuery.ajax(params);
    },
    _onItemAdded(line_item) {
      this.$addToCartText.html('added');
      this.$container.trigger({
        type: 'updateCart'
      })
    },
    _errorCallback(XMLHttpRequest, textStatus) {
      this.$addToCartText.html('Unavailable');
      this.$addToCart.addClass('').prop('disabled', true)
      if ((typeof errorCallback) === 'function') {
        // errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        // ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  });

  return AddToCart;
})();


/**
 * Inquire scripts
 * ------------------------------------------------------------------------------
 *
 * Handles Inquires
 *
 * @namespace Inquire
 */

slate.Inquire = (function() {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  
  function formToJSON(elements) {
  	return [].reduce.call(elements, function (data, element) {
  		data[element.name] = element.value;
  		return data;
  	}, {});
  }
  
  // Get Shopify Friendly URL String
  function getUrlString(data) {
  	var urlParameters = Object.entries(data).map(function (e) {
  		return e.join('=');
  	}).join('&');
  
  	return urlParameters;
  }
  
  function getUrlParameter(sParam) {
      var sPageURL = decodeURIComponent(window.location.search.substring(1)),
          sURLVariables = sPageURL.split('&'),
          sParameterName,
          i;
  
      for (i = 0; i < sURLVariables.length; i++) {
          sParameterName = sURLVariables[i].split('=');
  
          if (sParameterName[0] === sParam) {
              return sParameterName[1] === undefined ? true : sParameterName[1];
          }
      }
  }
  
  function Inquire(options) {
    this.$container = options.$container;
    this.product = options.product;

    this.$modal = $(options.modal);
    this.$form = $(options.form, this.$modal);
    this.$close = $('.close', this.$modal);
    this.$success = $('#mi-success-response', this.$modal);
    this.$error = $('#mi-error-response', this.$modal);

    this.$submit = $('button', this.form);
    
    this.$form.on("input", this._validate.bind(this));
    this.$form.on("submit", this._inquire.bind(this));
    // this.$form.on("submit", (event) => {
    //   event.preventDefault();
    //   this._onError({});
    // });
    
    this.$close.on('click', this.hide.bind(this));
    
  }

  Inquire.prototype = $.extend({}, Inquire.prototype, {
    show: function(event) {
      this.$modal.addClass('show');
    },
    hide: function(event) {
      console.log(event);
      this.$modal.removeClass('show');
    },
    _validate: function() {
      const valid = Object.values(formToJSON(this.$form[0].querySelectorAll("[name]")))
        .every(function(value) {
          return !!value;
        });

      if(valid) {
        this.$submit.removeAttr('disabled');
      } else {
        this.$submit.attr('disabled', 'disabled');
        
      }
    },
    _inquire: function(event) {
      event.preventDefault();
      // this.$addToCartText.html('adding');
      this._submit(this.$form);
    },
    _submit: function ($form) {
      // var form = evt.form;
      // this.$addToCartText.html('adding');
      var form = $form[0];
      var action = form.getAttribute("action");
      var inputs = form.querySelectorAll("[name]");
      var body = getUrlString(formToJSON(inputs));

      // console.log(action, inputs, body);
      // return;
      fetch(action, {
          method: 'POST',
          body: body,
          headers: {
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
              'Accept': 'text/html, */*; q=0.01',
              'X-Requested-With': 'XMLHttpRequest'
          }
		})
          .then(this._onSuccess.bind(this))
          .catch(this._onError.bind(this));
    },
    _onSuccess(res) {
      if (res.ok) {
        this.$form.hide();
        this.$success.show();
      } else {
        return this._onError(res);
      }
      this.$form.hide();
      this.$success.show();
    },
    _onError(err) {
      console.log(err);
      this.$error.show();
    }
  });

  return Inquire;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (function () {
  var selectors = {
    addToCart: "[data-add-to-cart]",
    addToCartText: "[data-add-to-cart-text]",
    comparePrice: "[data-compare-price]",
    comparePriceText: "[data-compare-text]",
    form: "form",
    originalSelectorId: "[data-product-select]",
    priceWrapper: "[data-price-wrapper]",
    productFeaturedImage: "[data-product-featured-image]",
    productJson: "[data-product-json]",
    productPrice: "[data-product-price]",
    productThumbs: "[data-product-single-thumbnail]",
    singleOptionSelector: ".single-option-selector__radio", //'[data-single-option-selector]'
    quantityInput: "[data-product-quantity]",
    quantityUpdate: "[data-product-quantity-update]",
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr("data-section-id");
    this.productSingleObject = JSON.parse(
      $(selectors.productJson, this.$container).html()
    );

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data("enable-history-state") || false,
      form: selectors.form,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject,
      quantityInput: selectors.quantityInput,
      quantityUpdate: selectors.quantityUpdate,
      addToCart: selectors.addToCart,
      addToCartText: selectors.addToCartText,
    };

    this.settings = {};
    this.namespace = ".product";
    this.variants = new slate.Variants(options);
    this.quantity = new slate.Quantity(options);
    this.addToCart = new slate.AddToCart(options);

    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on(
      "variantChange" + this.namespace,
      this.updateAddToCartState.bind(this)
    );
    this.$container.on(
      "variantPriceChange" + this.namespace,
      this.updateProductPrices.bind(this)
    );

    this.$quantityInput = $(selectors.quantityInput, this.$container);
    this.$container.on(
      "updateQuantity" + this.namespace,
      this.updateQuantity.bind(this)
    );

    // this.$container.on('addToCart' + this.namespace, this.addToCartFromForm.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(
        this.$featuredImage.attr("src")
      );
      // slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on(
        "variantImageChange" + this.namespace,
        this.updateProductImage.bind(this)
      );
    }
    this.$carousel = $(".product-images");
    this.$carousel.flickity({
      cellAlign: "left",
      contain: true,
      watchCSS: true,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: true,
      dragThreshold: 10,
      cellSelector: ".product-image",

      // selectedAttraction: 0.2,
      // friction: 0.8

      // friction: 0.25,
      // selectedAttraction: 0.01,
    });

    this.flkty = this.$carousel.data("flickity");
    // $carousel.on(
    //   "dragStart.flickity",
    //   () => (document.ontouchmove = e => e.preventDefault())
    // );
    // $carousel.on("dragEnd.flickity", () => (document.ontouchmove = () => true));

    this.initPhotoSwpipe();

    this.$inquireBtn = $('[data-inquire]', this.$container);

    if (this.$inquireBtn.length) {

      this.inquire = new slate.Inquire($.extend({}, options, {
        modal: '#modal-inquire',
        form: 'form'
      }));
      this.$inquireBtn.on('click', function(event) {
        event.preventDefault();
        this.inquire.show();
        console.log(this.inquire);
      }.bind(this));
    }
    
  }

  Product.prototype = $.extend({}, Product.prototype, {
    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function (evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass("hide");
      } else {
        $(selectors.addToCart, this.$container).prop("disabled", true);
        $(selectors.addToCartText, this.$container).html(
          theme.strings.unavailable
        );
        $(selectors.productPrice, this.$container).html("&mdash;");
        $(selectors.comparePrice, this.$container).html("");
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop("disabled", false);
        $(selectors.addToCartText, this.$container).html(
          theme.strings.addToCart
        );
      } else {
        $(selectors.addToCart, this.$container).prop("disabled", true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function (evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(
        selectors.comparePriceText,
        this.$container
      );

      $(selectors.productPrice, this.$container).html(
        slate.Currency.formatMoney(variant.price, theme.moneyFormat)
      );

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(
          slate.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          )
        );
        $compareEls.removeClass("hide");
      } else {
        $comparePrice.html("");
        $compareEls.addClass("hide");
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function (evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(
        variant.featured_image.src,
        this.settings.imageSize
      );

      this.$featuredImage.attr("src", sizedImgUrl);
    },

    updateQuantity: function (evt) {
      this.$quantityInput.val(evt.quantity);
    },

    // addToCartFromForm: function (evt) {
    //   var form = evt.form;
    //   var params = {
    //     type: 'POST',
    //     url: '/cart/add.js',
    //     data: jQuery(form).serialize(),
    //     dataType: 'json',
    //     success: function(line_item) {
    //       console.log(line_item);
    //       // if ((typeof callback) === 'function') {
    //       //   callback(line_item, form);
    //       // }
    //       // else {
    //       //   ShopifyAPI.onItemAdded(line_item, form);
    //       // }
    //     },
    //     error: function(XMLHttpRequest, textStatus) {
    //       if ((typeof errorCallback) === 'function') {
    //         // errorCallback(XMLHttpRequest, textStatus);
    //       }
    //       else {
    //         // ShopifyAPI.onError(XMLHttpRequest, textStatus);
    //       }
    //     }
    //   };
    //   jQuery.ajax(params);
    // },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function () {
      this.$container.off(this.namespace);
    },

    initPhotoSwpipe: function () {
      var flkty = this.flkty;
      var container = [];
      var $imageLinks = $(".product-images a");
      var ll = null;

      var flickityEnabled = function () {
        return flkty.$element.hasClass("flickity-enabled");
      };

      $imageLinks.each(function () {
        var $link = $(this).closest("a");
        var item = {
          src: $link.prop("href"),
        };
        container.push(item);
      });

      var init = false;
      var opened = false;
      var modal = null;

      var wraps = [];

      var $zoom = $(".product-images__zoom");

      $zoom.on("click", function () {
        openGallery(flkty.selectedIndex);
      });

      $imageLinks.on("click", function (event) {
        // Prevent location change
        event.preventDefault();

        if (flickityEnabled()) return;
        var $link = $(event.target).closest("a");
        var index = $imageLinks.index($link);
        openGallery(index);
      });

      var initialize = function () {
        modal = document.createElement("div");
        modal.classList.add("product-modal");

        var closeEl = document.createElement("div");
        closeEl.classList.add("product-modal__close");
        closeEl.innerHTML =
          '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17"><path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></path></svg>';
        closeEl.addEventListener("click", close);
        modal.append(closeEl);

        var list = document.createElement("div");
        list.classList.add("product-modal__list");
        modal.append(list);
        Array.from($imageLinks).forEach((el) => {
          var img = el.querySelector("img");
          img.removeAttribute("src");
          img.classList.add("lazy");
          var copy = img.cloneNode();
          var wrap = document.createElement("div");
          wrap.classList.add("product-modal__image");
          wrap.append(copy);
          list.append(wrap);
          wraps.push(wrap);
        });

        document.addEventListener("keyup", function (event) {
          event.code === "Escape" && close(event);
        });

        init = true;

        ll = new LazyLoad({
          container: modal,
        });
      };

      var close = function (event) {
        event && event.preventDefault();
        event && event.stopPropagation();

        if (!opened) {
          return;
        }

        modal.removeEventListener("click", close);

        modal.remove();
        document.body.classList.remove("body-overflow");
        opened = false;
      };

      var openGallery = function (index) {
        if (opened) {
          return;
        }
        if (init === false) {
          initialize();
        }

        opened = true;

        document.body.append(modal);

        if (flickityEnabled()) {
          wraps.forEach(function (el) {
            el.classList.remove("active");
          });
          wraps[index].classList.add("active");

          ll.update();
        } else {
          modal.addEventListener("click", close);
          if (index) {
            wraps[index].scrollIntoView();
          }
        }

        document.body.classList.add("body-overflow");
      };
    },

    isTouchDevice: function () {
      if ("ontouchstart" in window || window.TouchEvent) return true;

      if (window.DocumentTouch && document instanceof DocumentTouch)
        return true;

      var prefixes = ["", "-webkit-", "-moz-", "-o-", "-ms-"];
      var queries = prefixes.map((prefix) => `(${prefix}touch-enabled)`);

      return window.matchMedia(queries.join(",")).matches;
    },
  });

  return Product;
})();

(function () {
  let touchingCarousel = false,
    touchStartCoords;

  document.body.addEventListener("touchstart", function (e) {
    if (e.target.closest(".flickity-slider")) {
      touchingCarousel = true;
    } else {
      touchingCarousel = false;
      return;
    }

    touchStartCoords = {
      x: e.touches[0].pageX,
      y: e.touches[0].pageY,
    };
  });

  document.body.addEventListener(
    "touchmove",
    function (e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      let moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y,
      };

      if (Math.abs(moveVector.x) > 7) e.preventDefault();
    },
    { passive: false }
  );
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('show');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('show');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: "#RecoverPassword",
    hideRecoverPasswordLink: "#HideRecoverPasswordLink",
    signinForm: "#SigninForm",
    signupForm: "#SignupForm",
    toggleRadio: '.custom-radio input[name="customer_type"]',
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on("click", onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on("click", onShowHidePasswordForm);

  $(config.toggleRadio).on("change", onToggleForms);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === "#recover") {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $("#RecoverPasswordForm").toggleClass("hide");
    $("#CustomerLoginForm").toggleClass("hide");
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $(".reset-password-success");

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $("#ResetSuccess").removeClass("hide");
  }

  function onToggleForms(e) {
    // console.log(e)
    var $input = $(e.target).closest("input");

    if ($input.val() === 'signin') {
      $(config.signinForm).removeClass('hide');
      $(config.signupForm).addClass("hide");
    } else {
      $(config.signinForm).addClass("hide");
      $(config.signupForm).removeClass('hide');
    }
  }
})();


$(document).ready(function () {
  var sections = new slate.Sections();
  sections.register("product", theme.Product);
  sections.register("slideshow-section", theme.SlideshowSection);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $(".in-page-link").on("click", function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Apply a specific class to the html element for browser support of cookies.
  this.cart = new slate.Cart();
  if (this.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace(
      "supports-no-cookies",
      "supports-cookies"
    );
  }

  // $("#shopify-section-header").headroom({
  //   // offset: 75
  // });

  var blurTm = false;

  $(".header-search input[type='search']").on("focus", function () {
    $(".header-search").addClass("active");
  });

  $(".header-search input[type='search']").on("blur", function () {
    blurTm = true;
    setTimeout(function () {
      blurTm = false;
    });
    $(".header-search").removeClass("active");
  });

  $(".header-search .icon-search").on("click", function () {
    if (!$(".header-search").hasClass("active") && !blurTm) {
      $(".header-search input[type='search']")[0].focus();
    }
  });

  var $mobilNav = $(".mobile-nav");

  var onBodyClick = function (event) {
    if (!$(event.target).closest(".mobile-nav").length) {
      event.preventDefault();
      hideMobileNav();
    }
  };

  var addBodyListener = function () {
    $(window.document.body).on("click", onBodyClick);
  };

  var removeBodyListener = function () {
    $(window.document.body).off("click", onBodyClick);
  };

  var showMobileNav = function () {
    $mobilNav.addClass("show");
    addBodyListener();
  };
  var hideMobileNav = function () {
    $mobilNav.removeClass("show");
    removeBodyListener();
  };

  $(".menu-trigger").on("click", function (event) {
    event.stopPropagation();
    showMobileNav();
  });
  $(".close-menu").on("click", function () {
    hideMobileNav();
  });

  // $(".footer-link-nav li:eq(4)").on("click", function(e) {
  //   event.preventDefault();
  //   $("#newsletter-signup").addClass("show");
  // });
  // $("#newsletter-signup .close").on("click", function(e) {
  //   event.preventDefault();
  //   $("#newsletter-signup").removeClass("show");
  // });

  // PROMOBAR_HASH
  // var promoCookie = Cookies.set("promobar");
  // function inIframe() {
  //   try {
  //     return window.self !== window.top;
  //   } catch (e) {
  //     return true;
  //   }
  // }
  // if (promoCookie === PROMOBAR_HASH || inIframe() || true) {
  //   $("body").removeClass("promobar-enabled");
  //   $(".promobar-close").one("click", function() {
  //     $("html").removeClass("promobar-enabled");
  //     Cookies.set("promobar", PROMOBAR_HASH, { expires: 7 });
  //   });
  // }

  if (!$("html").hasClass("touchevents")) {
    var shopNav = $(".header-nav-left .site-nav--has-submenu");

    var timeout;
    shopNav.hover(
      function () {
        clearTimeout(timeout);
        shopNav.addClass("hover");
      },
      function () {
        clearTimeout(timeout);
        timeout = setTimeout(function () {
          shopNav.removeClass("hover");
        }, 150);
      }
    );
  }

  // setTimeout(function() {
  var threshold = Math.ceil(window.innerHeight * 0.5);
  var myLazyLoad = new LazyLoad({
    elements_selector: ".lazy",
    threshold: threshold,
  });
  window.myLazyLoad = myLazyLoad;
  // }, 100);

  
  var showMcModal = function () {
    var submitting = false;

    $(".signup-newsletter").addClass("show");

    $(".signup-newsletter .close").on("click", function () {
      $(".signup-newsletter").removeClass("show");

      Cookies.set("atnlsignup", "true", { expires: 14 });
    });

    $(".signup-newsletter input").on("focus", function () {
      $(".signup-newsletter #mce-error-response").html("");
    });

    $(".signup-newsletter form").on("submit", function (e) {
      e.preventDefault();
      var email = $('.signup-newsletter input[type="email"]').val();
      var isValid = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        email
      );

      if (!isValid) {
        $(".signup-newsletter #mce-error-response")
          .show()
          .html("<p>PLEASE SPECIFY A VALID EMAIL ADDRESS.</p>");
        return;
      }

      var $form = $(e.target).closest("form");
      var action = $form
        .attr("action")
        .replace("/post?", "/post-json?")
        .concat("&c=?");

      var data = {};
      var dataArray = $form.serializeArray();
      $.each(dataArray, function (index, item) {
        data[item.name] = item.value;
      });

      submitting = true;

      var showSuccess = function () {
        $(".signup-newsletter .form__actions").hide();
        $(".signup-newsletter .form-group").hide();
        $(".signup-newsletter #mce-success-response")
          .html("<p>Thank you for subscribing!</p>")
          .show();
      };

      $.ajax({
        // type: $form.attr("method"),
        url: action,
        data: data,
        cache: false,
        dataType: "json",
        // success: successCallback,
        dataType: "jsonp",

        // contentType: "application/json; charset=utf-8",
        error: function (err) {
          // alert(
          //   "Could not connect to the registration server. Please try again later."
          // );
          // console.log(err);
          submitting = false;
          showSuccess();
        },
        success: function (res) {
          submitting = false;
          showSuccess();

          // $("#mc-embedded-subscribe").val("subscribe");
          // if (data.result === "success") {
          //   // Yeahhhh Success
          //   console.log(data.msg);
          //   $("#mce-EMAIL").css("borderColor", "#ffffff");
          //   $("#subscribe-result").css("color", "rgb(53, 114, 210)");
          //   $("#subscribe-result").html(
          //     "<p>Thank you for subscribing. We have sent you a confirmation email.</p>"
          //   );
          //   $("#mce-EMAIL").val("");
          // } else {
          //   // Something went wrong, do something to notify the user.
          //   console.log(data.msg);
          //   $("#mce-EMAIL").css("borderColor", "#ff8282");
          //   $("#subscribe-result").css("color", "#ff8282");
          //   $("#subscribe-result").html("<p>" + data.msg.substring(4) + "</p>");
          // }
        },
      });
    });
  };

  var hasSeenSingup = Cookies.get("atnlsignup");

  if (!hasSeenSingup) {
    // setTimeout(function () {
    //   showMcModal();
    // }, 4000);
  }

  window.showMcModal = showMcModal;

  document.addEventListener('click', function(event) {
    if (event.target && /#subscribe/.test(event.target.href)) {
      event.preventDefault();
      showMcModal();
    }
  });

  document.addEventListener("shopify:section:load", function (event) {
    var sectionId = event.detail.sectionId;
    if (["1518286102327", "collection-list"].includes(sectionId)) {
      window.myLazyLoad && window.myLazyLoad.update();
    }
  });
});
